import * as THREE from 'three';
import { LineGeometry } from 'three/addons/lines/LineGeometry.js';
import { Line2 } from 'three/addons/lines/Line2.js';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { Object3D } from "./Viewer.Object3D.js";

class Member extends Object3D {
    constructor(startNode, endNode, material, labelText) {
        super();

        this.startNode = startNode;
        this.endNode = endNode;

        // Calculate direction vector from startNode to endNode
        const direction = new THREE.Vector3().subVectors(endNode.position, startNode.position);
        this.length = direction.length(); // Length of the member

        // Create geometry for the line
        const geometry = new LineGeometry();
        geometry.setPositions( [0, 0, 0, this.length, 0, 0] );

        this.line = new Line2( geometry, material );
        this.add( this.line ); // Add the line to the Member object

        // Position the Member at the startNode
        this.position.copy(startNode.position);

        // Align Member's local x-axis with the direction vector
        this.setDirection(direction);

        // Create AxesHelper
        const axesHelper = new THREE.AxesHelper(0.5);
        axesHelper.position.set(this.length / 2, 0, 0);
        const colors = axesHelper.geometry.attributes.color;

        colors.setXYZ( 0, 1, 0, 0 ); // index, R, G, B
        colors.setXYZ( 1, 1, 0, 0 ); // red
        colors.setXYZ( 2, 0, 1, 0 );
        colors.setXYZ( 3, 0, 1, 0 ); // green
        colors.setXYZ( 4, 0, 0, 1 );
        colors.setXYZ( 5, 0, 0, 1 ); // blue

        this.localAxes = axesHelper;
        this.add( axesHelper );

        this.label = new CSS2DObject( this.createLabelElement( labelText ) );
        this.label.position.set( this.length / 2, 0, 0 );
        this.add( this.label );
    }

    setDirection(direction) {
        // Create a quaternion that represents the rotation
        const quaternion = new THREE.Quaternion().setFromUnitVectors(
            new THREE.Vector3(1, 0, 0), // The Member's initial local x-axis
            direction.normalize() // The target direction vector
        );

        // Apply the quaternion to the Member to align it
        this.quaternion.copy(quaternion);

        // Since the local y-axis should remain parallel to the global y-axis,
        // additional adjustments should not be necessary unless the initial
        // orientation of the Member is not as assumed here.
    }

    createLabelElement(text) {
        const div = document.createElement('div');
        div.className = 'member-label';
        // div.classList.add('rounded-full');
        div.textContent = text;
        div.style.marginTop = '-1em';
        div.style.padding = '2px 4px';
        // div.style.background = 'rgb(255, 255, 255)';
        div.style.color = 'black';
        // div.style.borderRadius = '4px';
        div.style.borderWidth = '1px';
        div.style.borderColor = 'rgb(0, 0, 0)';
        div.style.fontSize = '12px';

        return div;
    }
}

export { Member };